// Thai (ภาษาไทย)
export default {
  nav: {
    home: 'หน้าแรก',
    wall: 'กระดาน',
    chat: 'ข้อความ',
    groups: 'กลุ่ม',
    users: 'ผู้ใช้',
    friends: 'เพื่อน',
    profile: 'โปรไฟล์ของฉัน',
    help: 'ช่วยเหลือ',
    membership: 'สมาชิก',
    logout: 'ออกจากระบบ',
    login: 'เข้าสู่ระบบ'
  },
  auth: {
    loginSubtitle: 'เข้าสู่ระบบเพื่อดำเนินการต่อ',
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    noAccount: 'ยังไม่มีบัญชี?',
    createAccount: 'สร้างบัญชี',
    loginFailed: 'เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบอีเมลและรหัสผ่าน',
    alreadyHaveAccount: 'มีบัญชีอยู่แล้ว?',
    register: 'ลงทะเบียน',
    name: 'ชื่อ',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    registrationSuccess: 'สร้างบัญชีสำเร็จ! คุณสามารถเข้าสู่ระบบได้แล้ว',
    registrationFailed: 'ไม่สามารถสร้างบัญชีได้'
  },
  home: {
    title: 'ชุมชน',
    tagline: 'พื้นที่สงบบนอินเทอร์เน็ต – ไม่มีโฆษณา',
    description: 'แบ่งปันชีวิตประจำวันกับครอบครัว เพื่อน และคนรู้จักใหม่ ไม่มีเสียงรบกวน ไม่มีการติดตาม ไม่ขายข้อมูล',
    features: {
      noAds: 'ไม่มีโฆษณา',
      simple: 'เรียบง่ายและชัดเจน',
      safe: 'บรรยากาศปลอดภัย + มีผู้ดูแล'
    },
    cta: {
      openWall: 'เปิดกระดาน',
      createProfile: 'สร้างโปรไฟล์ฟรี',
      goToWall: 'ไปที่กระดาน',
      readMore: 'อ่านเพิ่มเติมเกี่ยวกับแนวคิด'
    },
    pricing: 'เว็บไซต์นี้ใช้งานฟรี',
    pricingDetail: 'แต่พวกเราก็ต้องมีชีวิตอยู่ – กรุณาพิจารณาบริจาค'
  },
  wall: {
    title: 'กระดาน',
    subtitle: 'ที่นี่คุณจะเห็นโพสต์จากชุมชน',
    writePost: 'เขียนบนกระดาน',
    placeholder: 'เขียนโพสต์ของคุณที่นี่...',
    group: 'กลุ่ม',
    noGroup: 'ไม่มีกลุ่ม',
    selectImage: 'เลือกรูปภาพ',
    noFileSelected: 'ยังไม่ได้เลือกไฟล์',
    send: 'ส่ง',
    public: 'สาธารณะ',
    members: 'สมาชิก',
    private: 'ส่วนตัว',
    visibility: 'การมองเห็น'
  },
  groups: {
    title: 'กลุ่ม',
    subtitle: 'กลุ่มที่มีความหมาย – ท้องถิ่น งานอดิเรก การเดินทาง เดินเล่น – ติดตามได้ง่าย',
    createGroup: 'สร้างกลุ่ม',
    allGroups: 'กลุ่มทั้งหมด',
    myGroups: 'กลุ่มของฉัน',
    searchPlaceholder: 'ค้นหากลุ่ม...',
    noGroups: 'ไม่พบกลุ่ม',
    noMyGroups: 'คุณยังไม่ได้เป็นสมาชิกกลุ่มใดๆ',
    groupName: 'ชื่อกลุ่ม',
    description: 'คำอธิบาย',
    publicGroup: 'กลุ่มสาธารณะ (ทุกคนสามารถดูและเข้าร่วมได้)',
    private: 'ส่วนตัว',
    privateGroup: 'กลุ่มส่วนตัว',
    privateGroupMessage: 'นี่คือกลุ่มส่วนตัว คุณต้องได้รับคำเชิญเพื่อเข้าร่วม',
    notFound: 'ไม่พบกลุ่ม',
    notFoundMessage: 'กลุ่มนี้ไม่มีอยู่หรือถูกลบไปแล้ว',
    backToGroups: 'กลับไปที่กลุ่ม',
    createdBy: 'สร้างโดย',
    members: 'สมาชิก',
    postsCount: 'โพสต์',
    noDescription: 'ไม่มีคำอธิบาย',
    join: 'เข้าร่วม',
    leave: 'ออก',
    open: 'เปิด',
    leaveConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากกลุ่มนี้?',
    postsTab: 'โพสต์',
    membersTab: 'สมาชิก',
    invitesTab: 'คำเชิญ',
    noPosts: 'ยังไม่มีโพสต์ในกลุ่มนี้',
    joinToSee: 'เข้าร่วมกลุ่มเพื่อดูโพสต์',
    about: 'เกี่ยวกับ',
    createdOn: 'สร้างเมื่อ',
    editGroup: 'แก้ไขกลุ่ม',
    deleteConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มนี้? โพสต์ทั้งหมดจะถูกลบ',
    setMember: 'ตั้งเป็นสมาชิก',
    setModerator: 'ตั้งเป็นผู้ดูแล',
    setAdmin: 'ตั้งเป็นแอดมิน',
    removeMember: 'ลบออกจากกลุ่ม',
    removeMemberConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบ {name} ออกจากกลุ่ม?',
    changeCover: 'เปลี่ยนรูปปก',
    invalidImageType: 'ประเภทไฟล์ไม่ถูกต้อง กรุณาเลือกรูปภาพ',
    imageTooLarge: 'รูปภาพใหญ่เกินไป สูงสุด 5MB',
    inviteMembers: 'เชิญสมาชิก',
    inviteMember: 'เชิญ',
    searchUsers: 'ค้นหาผู้ใช้เพื่อเชิญ...',
    pendingInvites: 'คำเชิญที่รอดำเนินการ',
    noInvites: 'ไม่มีคำเชิญที่รอดำเนินการ',
    inviteSent: 'ส่งคำเชิญแล้ว!',
    cancelInvite: 'ยกเลิกคำเชิญ',
    invitedBy: 'เชิญโดย',
    acceptInvite: 'ยอมรับ',
    declineInvite: 'ปฏิเสธ',
    youHaveInvite: 'คุณได้รับคำเชิญเข้าร่วมกลุ่มนี้'
  },
  profile: {
    title: 'โปรไฟล์ของฉัน',
    editProfile: 'แก้ไขโปรไฟล์',
    myPosts: 'โพสต์ของฉัน',
    myGroups: 'กลุ่มของฉัน',
    overview: 'ภาพรวม',
    edit: 'แก้ไข',
    settings: 'ตั้งค่า',
    activity: 'กิจกรรม',
    bio: 'เกี่ยวกับฉัน',
    location: 'ที่อยู่',
    website: 'เว็บไซต์',
    birthday: 'วันเกิด',
    interests: 'ความสนใจ',
    joined: 'เข้าร่วมเมื่อ',
    posts: 'โพสต์',
    comments: 'ความคิดเห็น',
    reactions: 'รีแอคชัน',
    privacy: 'ความเป็นส่วนตัว',
    showRealName: 'แสดงชื่อจริงต่อสาธารณะ',
    showEmail: 'แสดงอีเมลต่อสาธารณะ',
    emailNotifications: 'การแจ้งเตือนทางอีเมล',
    showOnlineStatus: 'แสดงสถานะออนไลน์',
    showOnlineStatusHint: 'เมื่อปิด คุณจะแสดงเป็นออฟไลน์สำหรับผู้อื่น (โหมดไม่ระบุตัวตน)',
    onlineStatus: 'สถานะออนไลน์',
    online: 'ออนไลน์',
    away: 'ไม่อยู่',
    offline: 'ออฟไลน์',
    lastSeen: 'เห็นล่าสุด',
    changePassword: 'เปลี่ยนรหัสผ่าน',
    currentPassword: 'รหัสผ่านปัจจุบัน',
    newPassword: 'รหัสผ่านใหม่',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    uploadAvatar: 'อัปโหลดรูปโปรไฟล์',
    changeAvatar: 'เปลี่ยนรูปโปรไฟล์',
    removeAvatar: 'ลบรูปโปรไฟล์',
    bioPlaceholder: 'เล่าเกี่ยวกับตัวคุณ...',
    interestsPlaceholder: 'คุณสนใจอะไร?',
    saveChanges: 'บันทึกการเปลี่ยนแปลง',
    cancelChanges: 'ยกเลิก',
    profileUpdated: 'อัปเดตโปรไฟล์แล้ว!',
    passwordChanged: 'เปลี่ยนรหัสผ่านแล้ว!',
    avatarUploaded: 'อัปโหลดรูปโปรไฟล์แล้ว!',
    recentPosts: 'โพสต์ล่าสุด',
    recentComments: 'ความคิดเห็นล่าสุด',
    recentReactions: 'รีแอคชันล่าสุด',
    noPosts: 'ยังไม่มีโพสต์',
    noComments: 'ยังไม่มีความคิดเห็น',
    noReactions: 'ยังไม่มีรีแอคชัน',
    downloadData: 'ดาวน์โหลดข้อมูลของฉัน',
    deleteAccount: 'ลบบัญชี',
    deleteAccountWarning: 'การดำเนินการนี้จะลบบัญชีและข้อมูลทั้งหมดของคุณอย่างถาวร ไม่สามารถยกเลิกได้',
    age: 'ปี'
  },
  common: {
    loading: 'กำลังโหลด...',
    error: 'เกิดข้อผิดพลาด',
    success: 'สำเร็จ!',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    delete: 'ลบ',
    edit: 'แก้ไข',
    post: 'โพสต์',
    comment: 'ความคิดเห็น',
    quote: 'อ้างอิง',
    reply: 'ตอบกลับ',
    confirm: 'ยืนยัน',
    ok: 'ตกลง',
    data: 'ข้อมูล',
    viewAll: 'ดูทั้งหมด',
    noComments: 'ยังไม่มีความคิดเห็น เป็นคนแรกเลย!',
    writeComment: 'เขียนความคิดเห็น...',
    replyToComment: 'ตอบกลับความคิดเห็น...',
    deleteConfirm: 'ลบโพสต์นี้?',
    contentRequired: 'เนื้อหาต้องไม่ว่างเปล่า',
    updateFailed: 'ไม่สามารถอัปเดตโพสต์ได้',
    deleteFailed: 'ไม่สามารถลบโพสต์ได้',
    commentFailed: 'ไม่สามารถส่งความคิดเห็นได้'
  },
  users: {
    searchTitle: 'ค้นหาผู้ใช้',
    searchSubtitle: 'ค้นหาผู้ใช้ในชุมชน',
    searchPlaceholder: 'ค้นหาตามชื่อผู้ใช้ ชื่อ หรืออีเมล...',
    search: 'ค้นหา',
    searchHint: 'พิมพ์อย่างน้อย 2 ตัวอักษรเพื่อค้นหาผู้ใช้',
    resultsFound: 'พบ {count} ผู้ใช้',
    noResults: 'ไม่พบผู้ใช้ ลองคำค้นหาอื่น'
  },
  chat: {
    title: 'ข้อความ',
    searchConversations: 'ค้นหาการสนทนา...',
    noConversations: 'ยังไม่มีการสนทนา',
    noMessages: 'ยังไม่มีข้อความ',
    selectConversation: 'เลือกการสนทนาเพื่อเริ่มแชท',
    startNewChat: 'เริ่มแชทใหม่',
    searchUsers: 'ค้นหาผู้ใช้...',
    start: 'เริ่ม',
    typeMessage: 'พิมพ์ข้อความ...',
    you: 'คุณ',
    image: 'รูปภาพ',
    file: 'ไฟล์',
    today: 'วันนี้',
    yesterday: 'เมื่อวาน',
    typing: 'กำลังพิมพ์...',
    edited: 'แก้ไขแล้ว',
    editHistory: 'ประวัติการแก้ไข',
    editingMessage: 'กำลังแก้ไขข้อความ',
    deleteConfirm: 'ลบข้อความนี้?',
    messageDeleted: 'ข้อความถูกลบ',
    loadMore: 'โหลดเพิ่มเติม',
    fileTooLarge: 'ไฟล์ใหญ่เกินไป สูงสุด 2MB',
    viewProfile: 'ดูโปรไฟล์',
    sendMessage: 'ส่งข้อความ'
  },
  validation: {
    required: 'จำเป็นต้องกรอกช่องนี้',
    email: 'กรุณากรอกอีเมลที่ถูกต้อง',
    maxLength: 'สูงสุด {max} ตัวอักษร',
    passwordMatch: 'รหัสผ่านต้องตรงกัน'
  }
}